<template>
  <div>
    <div class="content-wizard">
      <!-- QUESTIONS -->
      <div class="row">
        <!-- TITULAIRE -->
        <div class="col-lg-6">
          <h3 class="font-bold">Titulaire du certificat d'immatriculation</h3>
          <!-- PERSONNE MORALE OU PHYSIQUE ? -->
          <div class="m-t">
            Le propriétaire est une personne&nbsp;:
            <div class="pull-right response">
              <div class="i-checks">
                <label>
                  <input
                    type="radio"
                    name="is_professional_radio"
                    :value="false"
                    v-model="isProfessional"
                    @change="ownerHasChange()"
                  />
                  &nbsp;Physique
                </label>
              </div>
              <div class="i-checks m-l">
                <label>
                  <input
                    type="radio"
                    name="is_professional_radio"
                    :value="true"
                    v-model="isProfessional"
                    @change="ownerHasChange()"
                  />
                  &nbsp;Morale
                </label>
              </div>
            </div>
          </div>
          <!-- VENDEUR/ACHETEUR TITULAIRE ? -->
          <template v-if="!isProfessional">
            <!-- VENDEUR -->
            <div v-if="isCurrentOwner" class="m-t">
              Le vendeur est-il le titulaire ? <a @click="fetchDocument('carRegistration')"><small>(voir carte grise)</small></a>
              <div class="pull-right response">
                <div class="i-checks">
                  <label>
                    <input
                      type="radio"
                      name="is_seller_owner_radio"
                      :value="true"
                      v-model="isSellerOwner"
                      @change="ownerHasChange()"
                    />
                    &nbsp;Oui
                  </label>
                </div>
                <div class="i-checks m-l">
                  <label>
                    <input
                      type="radio"
                      name="is_seller_owner_radio"
                      :value="false"
                      v-model="isSellerOwner"
                      @change="ownerHasChange()"
                    />
                    &nbsp;Non
                  </label>
                </div>
              </div>
            </div>
            <!-- ACHETEUR -->
            <div v-else class="m-t">
              L'acheteur sera-il le titulaire ?
              <div class="pull-right response">
                <div class="i-checks">
                  <label>
                    <input
                      type="radio"
                      name="is_buyer_owner_radio"
                      :value="true"
                      v-model="isBuyerOwner"
                      @change="ownerHasChange()"
                    />
                      &nbsp;Oui
                  </label>
                </div>
                <div class="i-checks m-l">
                  <label>
                    <input
                      type="radio"
                      name="is_buyer_owner_radio"
                      :value="false"
                      v-model="isBuyerOwner"
                      @change="ownerHasChange()"
                    />
                      &nbsp;Non
                  </label>
                </div>
              </div>
            </div>
          </template>
        </div>

        <!-- COTITULAIRE -->
        <div class="col-lg-6">
          <h3 class="font-bold">Cotitulaire</h3>
          <!-- VENDEUR -->
          <template v-if="isCurrentOwner">
            <div class="m-t">
              Y'a t-il un cotitulaire ? <a @click="fetchDocument('carRegistration')"><small>(voir carte grise)</small></a>
              <div class="pull-right response">
                <div class="i-checks">
                  <label>
                    <input
                      type="radio"
                      :value="true"
                      name="has_co_owner_radio"
                      v-model="hasCoOwner"
                    />
                    &nbsp;Oui
                  </label>
                </div>
                <div class="i-checks m-l">
                  <label>
                    <input
                      type="radio"
                      name="has_co_owner_radio"
                      :value="false"
                      v-model="hasCoOwner"
                    />
                    &nbsp;Non
                  </label>
                </div>
              </div>
            </div>
            <div v-if="hasCoOwner && !isSellerOwner" class="m-t">
              <span>
                Le vendeur est-il le cotitulaire ? <a @click="fetchDocument('carRegistration')"><small>(voir carte grise)</small></a>
              </span>
              <div class="pull-right response">
                <div class="i-checks">
                  <label>
                    <input
                      type="radio"
                      name="is_seller_co_owner_radio"
                      v-model="isSellerCoOwner"
                      :value="true"
                      @change="coOwnerHasChange()"
                    />
                    &nbsp;Oui
                  </label>
                </div>
                <div class="i-checks m-l">
                  <label>
                    <input
                      type="radio"
                      name="is_seller_co_owner_radio"
                      v-model="isSellerCoOwner"
                      :value="false"
                      @change="coOwnerHasChange()"
                    />
                    &nbsp;Non
                  </label>
                </div>
              </div>
            </div>
          </template>


          <!-- ACHETEUR -->
          <div v-else class="m-t">
            <template v-if="!isCurrentOwner">
              <div class="m-t">
                Y'a t-il un cotitulaire ? <a @click="fetchDocument('carRegistration')"><small>(voir carte grise)</small></a>
                <div class="pull-right response">
                  <div class="i-checks">
                    <label>
                      <input
                          type="radio"
                          :value="true"
                          name="has_co_owner_radio_buy"
                          v-model="hasCoOwner"
                      />
                      &nbsp;Oui
                    </label>
                  </div>
                  <div class="i-checks m-l">
                    <label>
                      <input
                          type="radio"
                          name="has_co_owner_radio_buy"
                          :value="false"
                          v-model="hasCoOwner"
                      />
                      &nbsp;Non
                    </label>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- RÉPONSES/FORMULAIRE -->
      <div class="row">
        <!-- TITULAIRE -->
        <div class="col-lg-6">
          <div class="row m-t-md">
            <!-- CIVILITE/NOM/PRENOM -->
            <div class="col-lg-12">
              <div class="response m-b-sm" :class="{'text-danger': errors.has('civility')}">
                <div class="i-checks">
                  <label>
                    <input
                      type="radio"
                      value="M"
                      name="civility"
                      :disabled="canDisableCivility()"
                      v-validate="'required'"
                      v-model="owner.civility"
                    />
                    &nbsp;Mr.
                  </label>
                </div>
                <div class="i-checks m-l">
                  <label>
                    <input
                      type="radio"
                      value="MME"
                      name="civility"
                      :disabled="canDisableCivility()"
                      v-model="owner.civility"
                    />
                    &nbsp;Mme.
                  </label>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group" :class="{'has-error': errors.has('lastName') && formSubmitted}">
                <label>Nom de naissance *</label>
                <input
                    name="lastName"
                    type="text"
                    class="form-control"
                    :disabled="isSellerOwner || isBuyerOwner"
                    placeholder="Saisir un nom"
                    v-validate="'required'"
                    v-model="owner.lastName"
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group" :class="{'has-error': errors.has('usedName') && formSubmitted}">
                <label>Nom d'usage (époux) (facultatif)</label>
                <input
                    name="usedName"
                    type="text"
                    class="form-control"
                    placeholder="Saisir un nom"
                    v-model="owner.usedName"
                />
              </div>
            </div>
            <div class="col-lg-12">
              <div class="form-group" :class="{'has-error': errors.has('firstName') && formSubmitted}">
                <label>Prénom *</label>
                <input
                  name="firstName"
                  type="text"
                  class="form-control"
                  :disabled="isSellerOwner || isBuyerOwner"
                  placeholder="Saisir un Prénom"
                  v-validate="'required'"
                  v-model="owner.firstName"
                />
              </div>
            </div>

            <div class="col-lg-6" v-if="!isCurrentOwner">
              <div class="form-group" :class="{'has-error': errors.has('birthDate') && formSubmitted}">
                <label>Date de naissance *</label>
                <input type="text"
                    name="birthDate"
                    class="form-control"
                    placeholder="Saisir votre date de naissance"
                     v-validate="'required'"
                     v-model="owner.birthDate"
                />
              </div>
            </div>

            <div class="col-lg-6" v-if="!isCurrentOwner">
             <div class="form-group" :class="{'has-error': errors.has('birthPlace') && formSubmitted}">
               <label>Lieu de naissance *</label>
                  <input
                    name="birthPlace"
                    type="text"
                    class="form-control"
                    placeholder="Saisir une ville"
                    v-validate="'required'"
                    v-model="owner.birthPlace"
                  />
              </div>
            </div>

              <!-- PERSONNE MORALE -->
            <template v-if="isProfessional" >
              <div class="col-lg-6">
                <div class="form-group" :class="{'has-error': errors.has('companyName') && formSubmitted}">
                  <label>Raison Sociale *</label>
                  <input
                    name="companyName"
                    type="text"
                    class="form-control"
                    placeholder="Saisir une raison sociale"
                    v-validate="'required'"
                    v-model="owner.companyName"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group" :class="{'has-error': !/^\d{14}$/.test(owner.siretNumber) && formSubmitted}">
                  <label>N° SIRET (14 caractères) *</label>
                  <input
                    name="siretNumber"
                    type="text"
                    class="form-control"
                    placeholder="Saisir un numéro SIRET"
                    @keyup="owner.siretNumber = owner.siretNumber.replace(/\D/, '')"
                    v-validate="'required|regex:^\\d{14}$'"
                    v-model="owner.siretNumber"
                  />
                </div>
              </div>
            </template>
            <!-- ADRESSE -->
            <div class="col-lg-12">
              <div class="form-group" :class="{'has-error': !owner.address.address && formSubmitted}">
                <label>Adresse{{ isProfessional ? ' du siège social' : '' }} *</label>
                <input
                  name="addressOwner"
                  type="text"
                  class="form-control"
                  placeholder="Saisir une adresse"
                  :disabled="isSellerOwner || isBuyerOwner"
                  v-model="owner.address.address"
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group" :class="{'has-error': !owner.address.zipCode && formSubmitted}">
                <label>Code postal{{ isProfessional ? ' du siège social' : '' }} *</label>
                <input
                  name="zipCodeOwner"
                  type="text"
                  class="form-control"
                  placeholder="Saisir un code postal"
                  :disabled="isSellerOwner || isBuyerOwner"
                  v-model="owner.address.zipCode"
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group" :class="{'has-error': !owner.address.city && formSubmitted}">
                <label>Ville{{ isProfessional ? ' du siège social' : '' }} *</label>
                <input
                  name="cityOwner"
                  type="text"
                  class="form-control"
                  placeholder="Saisir une ville"
                  :disabled="isSellerOwner || isBuyerOwner"
                  v-model="owner.address.city"
                />
              </div>
            </div>
            <div class="col-lg-12" v-if="orderInfo.warranty.price && !isCurrentOwner">
              <div class="form-group" :class="{'has-error': !owner.iban && formSubmitted}">
                <label>Iban{{ isProfessional ? ' du siège social' : '' }} *</label>
                <input
                    name="ibanOwner"
                    type="text"
                    class="form-control"
                    v-validate="'required'"
                    placeholder="Saisir iban"
                    v-model="owner.iban"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- COTITULAIRE -->
        <div v-if="hasCoOwner && isCurrentOwner" class="col-lg-6">
          <div class="row m-t-md">
            <div class="col-lg-12">
              <div class="response m-b-sm" :class="{'text-danger': errors.has('co_civility')}">
                <div class="i-checks">
                  <label>
                    <input
                      type="radio"
                      value="M"
                      name="co_civility"
                      :disabled="isSellerCoOwner"
                      v-validate="'required'"
                      v-model="coOwner.civility"
                    />
                    &nbsp;Mr.
                  </label>
                </div>
                <div class="i-checks m-l">
                  <label>
                    <input
                      type="radio"
                      value="MME"
                      name="co_civility"
                      :disabled="isSellerCoOwner"
                      v-model="coOwner.civility"
                    />
                    &nbsp;Mme.
                  </label>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group" :class="{'has-error': errors.has('co_lastname') && formSubmitted}">
                <label>Nom de naissance *</label>
                <input
                  name="co_lastName"
                  type="text"
                  class="form-control"
                  :disabled="isSellerCoOwner"
                  placeholder="Saisir un nom"
                  v-validate="'required'"
                  v-model="coOwner.lastName"
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group" :class="{'has-error': errors.has('co_usedName') && formSubmitted}">
                <label>Nom d'usage (époux) (facultatif)</label>
                <input
                    name="co_usedName"
                    type="text"
                    class="form-control"
                    :disabled="isSellerCoOwner"
                    placeholder="Saisir un nom"
                    v-model="coOwner.usedName"
                />
              </div>
            </div>
            <div class="col-lg-12">
              <div class="form-group" :class="{'has-error': errors.has('co_firstname') && formSubmitted}">
                <label>Prénom *</label>
                <input
                    name="co_firstName"
                    type="text"
                    class="form-control"
                    :disabled="isSellerCoOwner"
                    placeholder="Saisir un prénom"
                    v-validate="'required'"
                    v-model="coOwner.firstName"
                />
              </div>
            </div>
          </div>
        </div>


          <div v-if="hasCoOwner && !isCurrentOwner" class="col-lg-6">

          <div class="row m-t-md">
            <div class="col-lg-12">
              <div class="response m-b-sm" :class="{'text-danger': errors.has('co_buyer_civility')}">
                <div class="i-checks">
                  <label>
                    <input
                        type="radio"
                        value="M"
                        name="co_buyer_civility"
                        :disabled="isSellerCoOwner"
                        v-validate="'required'"
                        v-model="owner.civilityCo"
                    />
                    &nbsp;Mr.
                  </label>
                </div>
                <div class="i-checks m-l">
                  <label>
                    <input
                        type="radio"
                        value="MME"
                        name="co_buyer_civility"
                        :disabled="isSellerCoOwner"
                        v-model="owner.civilityCo"
                    />
                    &nbsp;Mme.
                  </label>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group" :class="{'has-error': errors.has('co_lastname') && formSubmitted}">
                <label>Nom de naissance *</label>
                <input
                    name="co_lastName"
                    type="text"
                    class="form-control"
                    :disabled="isSellerCoOwner"
                    placeholder="Saisir un nom"
                    v-validate="'required'"
                    v-model="owner.lastNameCo"
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group" :class="{'has-error': errors.has('co_usedName') && formSubmitted}">
                <label>Nom d'usage (époux) (facultatif)</label>
                <input
                    name="co_usedName"
                    type="text"
                    class="form-control"
                    placeholder="Saisir un nom"
                    v-model="owner.usedNameCo"
                />
              </div>
            </div>
            <div class="col-lg-12">
              <div class="form-group" :class="{'has-error': errors.has('co_firstname') && formSubmitted}">
                <label>Prénom *</label>
                <input
                    name="co_firstName"
                    type="text"
                    class="form-control"
                    :disabled="isSellerCoOwner"
                    placeholder="Saisir un prénom"
                    v-validate="'required'"
                    v-model="owner.firstNameCo"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <button
          type="button"
          class="btn btn-w-m btn-primary pull-right"
          @click="onSubmit"
        >
          J'ai contrôlé les informations
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { formatAddress, addressToString } from '../../../helpers/utils'
  import gql from 'graphql-tag'
  import moment from 'moment'

  export default {
    props: {
      ownerInformation: {
        type: Object,
        required: true
      },
      command: {
        type: Object,
        required: true
      },
      seller: {
        type: Object,
        required: false
      },
      buyer: {
        type: Object,
        required: false
      },
      isCurrentOwner: {
        type: Boolean,
        required: false,
        default: true
      }
    },

    data: () => ({
      owner: {
        civility: '',
        firstName: '',
        lastName: '',
        ownerType: 0,
        companyName: '',
        siretNumber: '',
        iban: '',
        address:{
          address:'',
          city:'',
          zipCode:'',
        },
        birthDate:'',
        birthPlace:'',
        usedName:'',

      },
      coOwner: {
        civility: '',
        firstName: '',
        lastName: '',
        usedName:'',
        address:{
          address:'',
          city:'',
          zipCode:''
        },
      },
      orderInfo: {
        warranty: {
          price: "",
        },
      },
      hasCoOwner: false,
      formSubmitted: false,
      isSellerOwner: false,
      isBuyerOwner: false,
      isSellerCoOwner: false,
      isProfessional: false,
      isBuyerCoOwner: false,
    }),

    computed: {
      commandId () {
        return this.$route.params.id
      },

      owners () {
        return this.isCurrentOwner ? this.ownerInformation.owners : this.ownerInformation.owner
      },

      ownerQuestions () {
        return this.ownerInformation.ownerQuestions
      },

      actualOwner () {
        return this.isCurrentOwner ? this.owners.owner : this.owners
      },

      actualCoOwner () {
        return this.isCurrentOwner ? this.owners.coOwner : null
      },

      ownerInformationMutation () {
        if (this.isCurrentOwner) {
          return gql`
            mutation {
              ownerInformation(orderId:"${this.commandId}",
              owners: {
                hasCoOwner: ${this.hasCoOwner}
                isSellerOwner: ${this.isSellerOwner}
                isSellerCoOwner: ${this.isSellerCoOwner}
                owner: {
                  civility: "${this.owner.civility}"
                  firstName: "${this.owner.firstName}"
                  lastName: "${this.owner.lastName}"
                  usedName: "${this.owner.usedName}"
                  ownerType: ${this.isProfessional ? 1 : 0}
                  companyName: "${this.owner.companyName}"
                  siretNumber: "${this.owner.siretNumber}"
                  address: {
                    address: "${this.owner.address.address}"
                    zipCode: "${this.owner.address.zipCode}"
                    city: "${this.owner.address.city}"
                  }
                }
                coOwner: {
                  civility: "${this.coOwner.civility}"
                  firstName: "${this.coOwner.firstName}"
                  lastName: "${this.coOwner.lastName}"
                  usedName: "${this.coOwner.usedName}"
                  address: {
                    address: "${this.coOwner.address.address}"
                    zipCode: "${this.coOwner.address.zipCode}"
                    city: "${this.coOwner.address.city}"
                  }
                }
              }
              ownerQuestions: {
                isProfessional: ${this.isProfessional}
              }
              ) {
                owners {
                  id
                  status
                  result
                }
                ownerQuestions {
                  id
                  status
                  result
                }
              }
            }`
        }
        return gql`
          mutation {
            futureOwner(orderId:"${this.commandId}",
              isBuyerOwner: ${this.isBuyerOwner}
              hasCoOwner: ${this.hasCoOwner}
              owner: {
                civility: "${this.owner.civility}"
                firstName: "${this.owner.firstName}"
                lastName: "${this.owner.lastName}"
                usedName: "${this.owner.usedName}"
                birthDate: "${this.owner.birthDate}"
                birthPlace: "${this.owner.birthPlace}"
                iban: "${this.owner.iban}"
                ownerType: ${this.isProfessional ? 1 : 0}
                companyName: "${this.owner.companyName}"
                siretNumber: "${this.owner.siretNumber}"
                address: {
                  address: "${this.owner.address.address}"
                  zipCode: "${this.owner.address.zipCode}"
                  city: "${this.owner.address.city}"
                }}
               coOwner: {
                civility: "${this.owner.civilityCo}"
                firstName: "${this.owner.firstNameCo}"
                lastName: "${this.owner.lastNameCo}"
                usedName: "${this.owner.usedNameCo}"
              })
            {
              id
              status
              result
            }
          }`
      }
    },
    async created () {
      this.hasCoOwner = this.owners.hasCoOwner
      await this.getOrderInformationQuery()
    },
    mounted () {
      if (this.actualOwner) {
        this.owner = Object.assign({}, this.actualOwner);
        this.$nextTick(function () {
            this.$refs.gmapAddress.$el.value = addressToString(this.owner.address);
        })
      }
      if (this.isCurrentOwner) {
        if (this.actualCoOwner && this.hasCoOwner) {
          this.coOwner = Object.assign({}, this.actualCoOwner);
          this.$nextTick(function () {
            this.$refs.gmapAddressCo.$el.value = addressToString(this.coOwner.address);
          })
        }

        if (this.owners.isSellerOwner === true) {
          this.isSellerOwner = true
        } else if (this.owners.isSellerOwner === false) {
          this.isSellerOwner = false
        }

        if (this.owners.isSellerCoOwner) {
          this.isSellerCoOwner = true
        }

        if (this.ownerQuestions) {
          this.isProfessional = !!this.ownerQuestions.isProfessional
        }
      } else {
        this.isBuyerOwner = this.ownerInformation.isBuyerOwner
        this.hasCoOwner = this.ownerInformation.hasCoOwner
        this.isProfessional = (this.owner.ownerType === 1)
      }
    },

    methods: {
      async getOrderInformationQuery () {
        const orderInfo = await this.$apollo.query({
          query: gql`
                    query {
                     getOrderInformation (orderId: ${this.commandId}) {
                        warranty { label price}

                    }
              }`,
          fetchPolicy: 'no-cache'
        })
        this.orderInfo.warranty.price = orderInfo.data.getOrderInformation.warranty.price

      },
      ownerHasChange() {
        if (this.isProfessional) {
          this.isSellerOwner = false;
          this.isBuyerOwner = false;
          this.hasCoOwner = false;
        }
        if (this.isSellerOwner || this.isBuyerOwner) {
          if (this.isSellerOwner) {
            if (this.isSellerCoOwner) {
              this.isSellerCoOwner = false;
              this.coOwnerHasChange();
            }
            this.owner.civility = this.seller.civility ? this.seller.civility : '';
            this.owner.firstName = this.seller.firstname;
            this.owner.lastName = this.seller.lastname;
            this.owner.usedName = this.seller.usedName;
            this.coOwner.usedName = this.seller.usedName;
            this.owner.birthDate = this.seller.birthdate;
            this.owner.birthPlace = this.seller.birthPlace;
            this.owner.address = Object.assign({}, this.seller.address);
          } else {
            this.owner.civility = this.buyer.civility ? this.buyer.civility : '';
            this.owner.firstName = this.buyer.firstname;
            this.owner.lastName = this.buyer.lastname;
            this.owner.usedName = this.buyer.usedName;
            this.owner.usedNameCo = this.buyer.usedNameCo;
            this.owner.birthDate = this.buyer.birthdate;
            this.owner.birthPlace = this.buyer.birthPlace;
            this.owner.address = Object.assign({}, this.buyer.address);
          }
        } else {
          this.owner.civility = '';
          this.owner.firstName = '';
          this.owner.lastName = '';
          this.owner.usedName = '';
          this.owner.birthDate = '';
          this.owner.birthPlace = '';
          this.owner.companyName = '';
          this.owner.siretNumber = '';
          this.resetAddress('owner');
        }
        this.$nextTick(function () {
          this.$refs.gmapAddress.$el.value = addressToString(this.owner.address);
        })
      },

      coOwnerHasChange() {
        if (this.isSellerCoOwner) {
          this.coOwner.civility = this.seller.civility ? this.seller.civility : '';
          this.coOwner.firstName = this.seller.firstname;
          this.coOwner.lastName = this.seller.lastname;
          this.coOwner.usedName = this.seller.usedName;
          this.owner.civilityCo = this.seller.civility ? this.seller.civility : '';
          this.coOwner.address = Object.assign({}, this.seller.address);
        } else if (this.isBuyerCoOwner) {
          this.coOwner.civility = this.buyer.civility ? this.buyer.civility : '';
          this.coOwner.firstName = this.buyer.firstname;
          this.coOwner.lastName = this.buyer.lastname;
          this.coOwner.usedName = this.buyer.usedName;
          this.owner.civilityCo = this.buyer.civility ? this.buyer.civility : '';
          this.coOwner.address = Object.assign({}, this.buyer.address);

        }
        else {
          this.coOwner.civility = '';
          this.coOwner.firstName = '';
          this.coOwner.lastName = '';
          this.coOwner.usedName = '';
          this.owner.civilityCo = '';
          this.resetAddress('coOwner');
        }
        this.$nextTick(function () {
          this.$refs.gmapAddressCo.$el.value = addressToString(this.coOwner.address);
        })
      },

      canDisableCivility() {
        return (this.isSellerOwner || this.isBuyerOwner) && this.owner.civility !== ""
      },

      async onSubmit () {
        this.formSubmitted = true

        let result = await this.$validator.validateAll()

        if (result && (this.isSellerOwner != null || !this.isCurrentOwner)) {
          this.$apollo.mutate({
            mutation: this.ownerInformationMutation
          }).then(() => {
            this.showBanner('success', 'Les informations ont bien été modifiées.')
            this.$parent.toggleBlock(2)
          })
        } else {
          this.showBanner('danger', 'Veuillez remplir les champs obligatoires (*)')
        }
      },

      resetAddress (type) {
        this[type].address = {
          address: '',
          zipCode: '',
          city: ''
        };
      },

      onPlaceChanged (place, type) {
        this[type].address = formatAddress(place)
      },

      getDocumentId (type) {
        const query = gql`
          query {
            projectDocument(orderId: ${this.$parent.commandId}) {
              ${type} {
                id
              }
            }
          }`

        return this.$apollo.query({
          query: query
        })
      },

      getBase64Document (id) {
        const query = gql`
          query {
            showDocument(
            files: {
              fileId: ${id}
            })
            {
              files {
                base64
                id
              }
            }
          }`

        return this.$apollo.query({
          query: query
        })
      },

      async fetchDocument (type) {
        try {
          let response = await this.getDocumentId(type)
          const documentId = response.data.projectDocument[0][type].id
          if (!documentId) {
            throw 'no_document_id'
          } else {
            response = await this.getBase64Document(documentId)
            const base64file = response.data.showDocument.files[0].base64
            this.showFileViewer({
              image: base64file
            })
          }
        } catch (e) {
          this.showBanner('danger', 'Le document associé n\'a  pu être récupéré.')
        }
      }
    }
  }
</script>
